import { InteractionRequiredAuthError } from "@azure/msal-browser";

const tokenRefreshBufferSeconds = 300;

export function isInteractionRequiredError(error) {
  const errors = [error, error?.cause, error?.networkError, ...(error?.graphQLErrors || [])].filter(Boolean);

  return errors.some(
    (currentError) =>
      currentError instanceof InteractionRequiredAuthError ||
      [
        "interaction_required",
        "login_required",
        "consent_required",
        "no_tokens_found",
        "monitor_window_timeout",
      ].includes(currentError?.errorCode),
  );
}

export function isAuthenticationResponseInIframe(browserWindow = window) {
  if (browserWindow.self === browserWindow.top) {
    return false;
  }

  const hashParams = new URLSearchParams(browserWindow.location.hash.slice(1));
  return hashParams.has("state") && (hashParams.has("code") || hashParams.has("error"));
}

export async function acquireAuthenticationToken(instance, account, scopes) {
  if (!account) {
    throw new Error("No active account is available");
  }

  let authResult = await instance.acquireTokenSilent({
    scopes,
    account,
  });
  const expiresAt = authResult.idTokenClaims?.exp;

  if (!expiresAt || expiresAt - Date.now() / 1000 < tokenRefreshBufferSeconds) {
    authResult = await instance.acquireTokenSilent({
      scopes,
      account,
      forceRefresh: true,
    });
  }

  return authResult.idToken;
}
